/** @jsxImportSource react */
import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Box, Toolbar } from '@mui/material'
import Navbar from './Navbar'
import Sidebar, { DRAWER_WIDTH } from './Sidebar'
import { LockedScreen, SubscriptionBanner } from '../billing/SubscriptionNotice'
import { useSubscription } from '../../hooks/useCrmQueries'

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false)
  const { pathname } = useLocation()
  const { data: sub } = useSubscription()
  // locked: only billing works (for admins); everything else would fail anyway
  const locked = sub?.billingEnabled && sub.phase === 'LOCKED' && !(sub.canManage && pathname === '/settings/billing')

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Navbar onMenuClick={() => setMobileOpen(true)} />
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0, width: { md: `calc(100% - ${DRAWER_WIDTH}px)` } }}>
        <Toolbar variant="dense" />
        <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1400, mx: 'auto' }}>
          <SubscriptionBanner />
          {locked ? <LockedScreen sub={sub} /> : <Outlet />}
        </Box>
      </Box>
    </Box>
  )
}

export default Layout
